// extracted by mini-css-extract-plugin
export default {"profilesLabel":"profilesLabel---Os98v"};